import React from 'react';
import { View, Text, Image, StyleSheet } from '../Primitives'

import Manifests from './Manifests';
import dayjs from 'dayjs';
import { usePdfType } from '../Hooks/PdfTypeContext';
import { authDetails } from '../../../Services/AuthContext';
import { IChangeCharter } from '../../../Models/IChangeCharter';
import { IRoute } from '../../../Models/IRoute';
import { IBidRoute } from '../../../Models/IBidRoute';

const boxStyle = StyleSheet.create({
    parentBox: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        marginBottom: 15,
    },
    dateBox: {
        display: 'flex',
        flex: 1,
        marginBottom: 5,
        padding: 5,
        backgroundColor: '#3E4D57'

    },
    dateText: {
        fontSize: 15,
        color: '#FFF',
        fontFamily: 'RobotoBold',
    },
    routeBox: {
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        marginTop: 0,
        marginBottom: 15,
    },
    routeDetail: {
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
    },
    manifestDetail: {
        display: 'flex',
        flex: 1,
        backgroundColor: '#eceded',
        fontSize: 6,
        flexDirection: 'column',
        padding: 8,
        marginLeft: 5,
        marginBottom:10
    },
    routeHeader: {
        fontSize: 16,
        backgroundColor: '#F47820',
        flexDirection: 'row',
        padding: 5,
        color: '#fff',
        fontFamily: 'RobotoBold',

    },
    routeHeaderQg: {
        fontSize: 16,
        backgroundColor: '#006CAA',
        flexDirection: 'row',
        padding: 5,
        color: '#fff',
        fontFamily: 'RobotoBold',

    },
    flexContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        fontFamily: 'RobotoBold',
    },
    flexBox: {
        display: 'flex',
        flex: 1,
        marginBottom: 0
    },
    routeText: {
        display: 'flex',
        flex: 1,
        marginBottom: 0,
        textAlign: 'left',
        fontFamily: 'RobotoBold',
    },
    leftText: {
        fontSize: 11,
        fontFamily: 'RobotoRegular',
    },
    rightText: {
        fontSize: 11,
        textAlign: 'left',
        fontFamily: 'RobotoBold'
    },
    departTime: {
        fontSize: 18,
        fontFamily: 'RobotoBold'
    },
    image: {
        width: 50,
        height: 'auto',
        marginRight: '5',
        marginLeft: '5',
        flex: .2,
        display: 'flex',
        marginTop: 'auto',
        marginBottom: 'auto'

    },
    bodyContainer: {
        marginLeft: 30,
        marginRight: 30,
        display: 'flex',
    },
})

interface Props {
    auth: authDetails;
    charter: IChangeCharter;
    route: IRoute & IBidRoute & { notes: string };
    bidHistory: boolean;
    showWeight?: boolean;
    newPdfType?: string;
}


const Route = ({ auth, charter, route, bidHistory, showWeight, newPdfType }: Props) => {
    const pdfType = usePdfType() as unknown as string;
    newPdfType=pdfType?pdfType:newPdfType;
    const qg = newPdfType === 'Itinerary' ? false : newPdfType === 'ItineraryQGov' ? true : false;
    const minutesOffset = charter.clientDepartment ? (charter.clientDepartment.itineraryMinutesOffset ? charter.clientDepartment.itineraryMinutesOffset : 0) : (charter.client.itineraryMinutesOffset ? charter.client.itineraryMinutesOffset : 0);
    const departTime = dayjs(route.departTime).subtract(minutesOffset, "minute");
    //const fromState = route.fromState && route.fromState.startsWith("Q") ? "QLD" : route.fromState;
    //const toState = route.toState && route.toState?.startsWith("Q") ? "QLD" : route.toState;
    const flightArr = route.flightTime ? route.flightTime.split(':') : ['0', '0'];
    let hours = 0;
    let minutes = 0;
    if (flightArr.length === 2) {
        hours = parseInt(flightArr[0]);
        minutes = parseInt(flightArr[1]);
    }
    if (flightArr.length === 1) {
        minutes = parseInt(flightArr[0]);
    }
    //const arriveTime = fromState === toState ? departTime.add(60 * hours + minutes, 'minute') : null;
    const arriveTime =  departTime.add(60 * hours + minutes, 'minute');
    return <View style={boxStyle.bodyContainer} minPresenceAhead={50}>
        <View style={boxStyle.parentBox}>

            <View style={boxStyle.dateBox}>
                <Text style={boxStyle.dateText} >{dayjs(route.departTime).subtract(minutesOffset, "minute").format("dddd DD MMMM YYYY")}</Text>
            </View>
            <View style={boxStyle.routeBox}>
                <View style={boxStyle.routeDetail}>
                    <View style={qg ? boxStyle.routeHeaderQg : boxStyle.routeHeader}>
                        <Text style={boxStyle.routeText} >
                            {route.from ? route.from.toUpperCase() : ""}
                        </Text>
                        <Image style={boxStyle.image} src={"/img/pdf/white-jet.png"} />

                        <Text style={boxStyle.routeText}>
                            {route.to ? route.to.toUpperCase() : ""}
                        </Text>
                    </View>

                    <View style={boxStyle.flexContainer}>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.leftText}>Departure Time:</Text>
                        </View>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.departTime}>{departTime.format("HH:mm A")}</Text>
                        </View>
                    </View>
                    {!bidHistory ? <View style={boxStyle.flexContainer}>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.leftText}>Flight Time:</Text>
                        </View>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.departTime}>{route.flightTime}</Text>
                        </View>
                    </View> : null}
                    {route.techstopReason ? <View style={boxStyle.flexContainer}>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.leftText}>Tech Stop/Fuel Stop:</Text>
                        </View>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.rightText}>{route.techstopLocation}</Text>
                        </View>
                    </View> : null}
                    {arriveTime && !bidHistory ? <View style={boxStyle.flexContainer}>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.leftText}>Arrival Time:</Text>
                        </View>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.departTime}>{arriveTime.format("HH:mm A")}</Text>
                        </View>
                    </View> : null}
                    { (!bidHistory && route.aircraft) ? route.aircraft.map((x, i) =>
                        <View key={i} style={boxStyle.flexContainer}>
                            <View style={boxStyle.flexBox}>
                                {i === 0 ? <Text style={boxStyle.leftText}>Aircraft:</Text> : null}
                            </View>
                            <View style={boxStyle.flexBox}>
                                <Text style={boxStyle.rightText}>{x.type + ' ' + x.licenseNumber}</Text>
                            </View>
                        </View>) : null}
                    {!bidHistory ? <View style={boxStyle.flexContainer}>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.leftText}>Available Payload:</Text>
                        </View>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.rightText}>{route.payload} kg</Text>
                        </View>
                    </View> : null}
                    {route.notes ? <View style={boxStyle.flexContainer}>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.leftText}>Notes</Text>
                        </View>
                        <View style={boxStyle.flexBox}>
                            <Text style={boxStyle.rightText}>{route.notes}</Text>
                        </View>
                    </View> : null}
                </View>
                <View style={boxStyle.manifestDetail}>
                    <Manifests auth={auth} charter={charter} manifest={route.manifest} showWeight={showWeight} />
                </View>                
            </View>
        </View>
    </View>
}

export default Route;